var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"600px"}},[_c('vue-data-table',{attrs:{"item-key":"id","headers":_vm.headers,"items":_vm.items},on:{"click:row":_vm.onClickRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }